module.exports = __webpack_public_path__ + "img/video705.05fc3ace.jpg";